export const ADMIN_GROUPS_API_BASE_PATH = '/admin/groups';
export const ADMIN_GROUPS_API_PATH = ADMIN_GROUPS_API_BASE_PATH + '/';
export const ADMIN_GROUPS_WITH_DEPARTMENT_MARKER_PATH = 'with-department-marker';
export const GROUP_CONTEXT_API_PATH = '/common/groups/';
export const WORK_TIME_STATUS_PATH = '/common/time/status';
export const WORK_TIME_LOGIN_PATH = '/common/time/login';
export const WORK_TIME_LOGOUT_PATH = '/common/time/logout';
export const DEAL_PAYROLL_USER_SETTINGS_PATH = '/common/head/user/';
export const DEAL_PAYROLL_GROUP_PATH = '/common/head/group/';
export const DEAL_PAYROLL_REPORT_PATH = '/common/user/';
export const DEAL_PAYROLL_CATALOG_PATH = '/admin/deal-payroll/catalog';
export const DEAL_PAYROLL_RATES_PATH = '/admin/deal-payroll/rates';
export const REPORT_PROGRESS_PATH = '/common/report/progress/';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/api-connect.service.constants.ts